import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import "./dashboardmobile.css";
import filterIcon from "../../assets/FilterIcon.svg";
import Skeleton from "../../components/skeleton/Skeleton";

import axios from 'axios';

import { useSearchParams, useLocation, useNavigate } from "react-router-dom";

import { SearchIcon } from "../../assets/SearchIcon";
import { ClearIcon } from "../../assets/ClearIcon";

import MasterButton, { ButtonLayoutType, ButtonSize, ButtonVariation } from "../../components/button/MasterButton";
import InputfieldWithPlaceholder, { InputfieldType } from "../../components/inputfieldwithplaceholder/Inputfieldwithplaceholder";

import ModalOverlay from "../../components/modal/ModalOverlay";

import CustomTimeSelectionButtonBar from "../../components/customTimeSelectionButtonBar/customTimeSelectionButtonBar";
import DashboardSelectStudiesModal from "../dashboard/dashboardSelectStudiesModal/dashboardSelectStudiesModal";
import DashboardParticipantDetailsModal from '../dashboard/dashboardParticipantDetailsModal/dashboardParticipantDetailsModal';


import { useSelector , useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../context/store';

import { updateStudyInfo } from '../../context/studyInfoSlice';

import { useSharedState } from '../../context/sharedState';

import { DateRange } from "react-day-picker";

import DashboardMobileParticipantInnerDetail from "./dashboardMobileParticipantInnerDetail/dashboardMobileParticipantInnerDetail"

import moment from "moment-timezone";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const VERSION = process.env.REACT_APP_API_VERSION;

type ParticipantStudyAnalytics = {
    homeostasisData: number; // range: 70 - 90
    activityData: number; // range: 0 - 5
    hotData: number; // range: 0 - 5
    offWristData: number; // range: 0 - 5
    coldData: number; // range: 0 - 5
    noData: number; // Always 0
}

type ParticipantStudyDetails = {
    isPinned: boolean;
    hasAnomaly: boolean;
    anomalyPercentage: number; // range: 0 to 10
    hasError: boolean;
    participantID: string; // Example: 'LAS001NNN'
    dailyData: ParticipantStudyAnalytics;
    weeklyData: ParticipantStudyAnalytics;
    lastUpdate: string;
};

type ParticipantModalDetails = {
    participant_name: string;
    participant_euid: string;
};

type StudyInfo = {
  StudyOrg: string;
  StudyName: string;
};

const DashboardMobile = () => {

    const [isLoading, setLoading] = useState(true);

    const [isModalVisible, setModalVisible] = useState(false);
    const [currentTimeline, setCurrentTimeline] = useState<string>('1 Week');
    const [timelineDays, setTimelineDays] = useState<number>(1);
    
    const [noData, setNoData] = useState(false);

    const { sharedState, setSharedState } = useSharedState();
    const [isRefreshing, setRefereshing] = useState(false);

    // --- Below hooks to manage participant details models --------------------------

    const [isParticipantDetailModalVisible, setIsParticipantDetailModalVisible] = useState<boolean>(false);
    const [currentParticipantInFocus, setCurrentParticipantInFocus] = useState<ParticipantModalDetails>({'participant_name' : "", 'participant_euid': ""});
    



    // --- Below states and function for search functionality --------------

    const [searchQuery, setSearchQuery] = useState("");
    const [searchActive, setSearchActive] = useState(false);

    // Initialize an empty array of any type
    const [items, setItems] = useState<ParticipantStudyDetails[]>([]);
    const [placeholderValue, setplaceholderValue] = useState("");

    const dispatch: AppDispatch = useDispatch();

    const search = (query: string) => {
        console.log("Search Query:", query);
        setSearchQuery(query);
    };

    //  --------------------------------------------------------------------

    const [selectedDateRange, setSelectedDateRange] = useState<DateRange | undefined>({
        from: undefined,
        to: undefined,
    });

    const [selectedTimezoneString, setSelectedTimezoneString] = useState<string>("");

    // Set default timezone to the browser's timezone
    useEffect(() => {
        const browserTimezone = moment.tz.guess(); // Get the browser's timezone
        setSelectedTimezoneString(browserTimezone);
    }, []);
    
      // ------------------------------------------------------------------------------------------------------------------------
    // The below is the callback function that will handle passing timeline(TimeRange) data from SelectStudiesModal to this Dashboard 
    // Callback function to handle data from the child
    const handleTimelineFromModal = (timeperiod: string) => {
        // setCurrentTimeline(timeperiod);
    };

    const storeStudy = useSelector((state: RootState) => state.studyInfo);
    const storeStudyID = useSelector((state: RootState) => state.studyMapping);

    const [plotData, setPlotData] = useState<any>(null);
    const [studyName, setStudyName] = useState<string>("");
    const [noDataParticipants, setNoDataParticipants] = useState<string[][]>([]);

    // ---------------------------------------------------------------------------------------------------------------------------
    // Below state keeps track whether the component and its being data being loaded by DynamicURL
  
    const [participantDetailURLRedirect, setparticipantDetailURLRedirect] = useState<boolean>(false);
    const [selectedStudyIdFromDynamicURL, setSelectedStudyIdFromDynamicURL] = useState<string | null>(null);
    const [requestedParticipantFromDynamicURL, setRequestedParticipantFromDynamicURL] = useState<{ participant_euid: string; participant_name: string }>({
      participant_euid: "",
      participant_name: "",
    });
  
    const [requestedDateRangeFromDynamicURL, setRequestedDateRangeFromDynamicURL] = useState<DateRange | undefined>({
          from: undefined,
          to: undefined,
    });

    useEffect(()=> {

        if (storeStudy && !participantDetailURLRedirect) {

            let StudyOrg = storeStudy.study.StudyOrg
            let StudyName = storeStudy.study.StudyName

            if(StudyOrg == "All Studies"){
            setModalVisible(true);
            }else if(StudyName == ""){
            setModalVisible(true);
            }else {
            setModalVisible(false);
            }

            // !!!!!!!!!!!!!!!!!!!!! Add condition to handle error studies

        }

    }, [storeStudy])

    // Function to calculate relative datetime
    function getRelativeDate(date: Date, adjustment: { days?: number; months?: number; years?: number }): Date {
        const newDate = new Date(date); // Create a copy of the date object

        if (adjustment.days) {
        newDate.setUTCDate(newDate.getUTCDate() + adjustment.days);
        }
        if (adjustment.months) {
        newDate.setUTCMonth(newDate.getUTCMonth() + adjustment.months);
        }
        if (adjustment.years) {
        newDate.setUTCFullYear(newDate.getUTCFullYear() + adjustment.years);
        }

        return newDate;
    
    }

    useEffect(() => {
    
        const now = new Date();
    
        const currentDate = new Date(Date.UTC(
            now.getUTCFullYear(),
            now.getUTCMonth(),
            now.getUTCDate(),
            now.getUTCHours(),
            now.getUTCMinutes(),
            now.getUTCSeconds(),
            now.getUTCMilliseconds()
        ));
    
        if(currentTimeline == "Today"){
          
          setSelectedDateRange({
            from: getRelativeDate(currentDate, { days: -1 }),
            to: currentDate,
          })
          setTimelineDays(1)
    
        }else if(currentTimeline == "3 Days"){
    
          setSelectedDateRange({
            from: getRelativeDate(currentDate, { days: -3 }),
            to: currentDate,
          })
          setTimelineDays(3)
    
        }else if(currentTimeline == "1 Week"){
    
          setSelectedDateRange({
            from: getRelativeDate(currentDate, { days: -7 }),
            to: currentDate,
          })
          setTimelineDays(7)
    
        }
        // else if(currentTimeline == "All Time"){
        //   timePeriod = 1000;
        // }
    
    
    }, [currentTimeline])

    const handleTimeRangeSelection = (data: DateRange, timezoneString: string, noOfDaysSelected?: number) => {
        console.log('DateTime Range received from CustomTimeSelectionButtonBar:', data); // Log for debugging
        // -- Now after you get the correct time here -- manage it effectively to call the api to fetch the dashboard or relevant data.
        setSelectedDateRange(data); 
        setSelectedTimezoneString(timezoneString);
        
        if(noOfDaysSelected){
            setTimelineDays(noOfDaysSelected)
        }
        
        // 1. Now store this timezoneString in a state - with a useEffect default value of current browser's timezone
        // 2. And pass this timezoneString with every API Call. 
        // 3. This needs to be done in both the dashboard and dashboardParticipantDetailsModal Page..
        // Technical Error Indicator
        // Granular level of reading of anomaly data
        // Labeling tool - in the plots itself

        // 4. In the back end its just a matter of converting all the API's
        // Next send text to Sam about the loss of real estate in participant details modal

        // After timezone integration -> Next work on the dashboard details page - add all the labels, and dynamic time selection 
        // - complete - and then deployment and code quality standards discussion.. 
        // Focus on completing the POC. - as many features as possible..

    };


    // -----------------------------------------------------------------------------------------------------------------------------

    const [searchParams] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();
    const paramValue = searchParams.get("intent");

    // Strategy how to handle this
    // 1. [Done] The select studies menu will not be opened incase URL Param strings are present
    // 2. [Done] The Dashboard will continue to load the studies from backend (for future use)
    // 3. [Done] A request for decrypting the encrypted query strings will be made
    // - Cleanup query string parameters when it is consumed the first time...
    // 4. Response containing the study ID will be used to set the current study in the dashboard and setting the current study state 
    // 5. This will load up the main dashboard data
    // 6. Later Participant Details will sent with this data to be shown (You need to modify participant details to work properly)

    // -- The above needs to be implemented without modifying any existing code... and should work with non encrypted query string parameters also

    
    // [Done] Verify which study is loaded in the above case? (All studies is loaded - need to change with respect to decrypted data)

    // [Done] Ensure that studies are loaded still --- This is loaded automatically irrespective of anything... done
    // [Done] Use the same technique useEffect used in selectstudiesmodal to update current dashboard to the current study (if both StudyData is loaded and Decrypted String is loaded)

    // 1. [Done] Create a query parameter string now
    // 2. Integrate all functionality from frontend
    // 3. Go to cloud and integrate encryption there.. that's it..

    // After you complete the functionality make this part component into a module file .ts file


    // TODO: 
    // Also verify whether all URL's are redirected to SPA

    // Also need to disable selectstudies dropdown when its loading

    // Implement this for dashboardmobile
    // Make the cloud part a module
    




    useEffect(() => {

      const paramValue = searchParams.get("intent");
      if(paramValue == "ParticipantDetailURLRedirect"){

        // Hide Select Studies menu
        setModalVisible(false);
        setparticipantDetailURLRedirect(true); // This will not make selectstudies modal visible when the studie data are loaded 
        
        const fetchDecryptedParams = async () => {

          console.log("Fetching Decrypted Parameter Strings")

          try {
            const response = await axios.get(
              `${BASE_URL}/getDecryptedParticipantData/?data=${searchParams.get("data")}`,
            );

            if (response.data['statusCode'] === 200) { 
              console.log("UNTOUCHED Decrypted DATA", response.data['body']);

              // 1. Manage Study selection here globally

              // Store it a state 
              // If all the states matches 1. Decrypted Data Loaded  2. Studies loaded in global state 3. If study present in studies.
              setSelectedStudyIdFromDynamicURL(response.data['body']['study'])
              setRequestedParticipantFromDynamicURL({participant_euid : response.data['body']['participant_euid'], participant_name : response.data['body']['participant_name']})

              setRequestedDateRangeFromDynamicURL({from : response.data['body']['timerange_from'], to: response.data['body']['timerange_to']})

              // 2. Load Main Dashboard Data based on this study and 
              /// Load Participant Data into an intermediate state value


              // Edge case to be solved (Later) : How to manage user permissioning here. (User Based Access Control)
              // [Done] How to handle edge case if any particular study is not present? - make shift solution for now -- show select studies modal incase study_id wrong
              // [Done] For this to work - we need decrypted value as well as studies in global state (handled this by using another useEffect)

              

            } else if(response.data['statusCode'] === 204){
              console.log("UNTOUCHED DATA", JSON.parse(response.data['body']));
            } else {
              console.log("UNTOUCHED ERROR", response);
              throw new Error('Failed to fetch data');
            }

          } catch (err: unknown) {
            if (axios.isAxiosError(err)) {
              // The error is an Axios error
              if (err.response) {
                // Server responded with a status other than 2xx
                console.error('Error response:', err.response);
                console.error('Status code:', err.response.status);
                console.error('Error data:', err.response.data);
              } else if (err.request) {
                // Request was made but no response was received
                console.error('No response received:', err.request);
              } else {
                // Something else happened during setup
                console.error('Error', err.message);
              }
            } else {
              // The error is not an Axios error
              console.error('Unknown error:', err);
            }
          } finally {

          }

        };

        fetchDecryptedParams();
        // seturlBasedRouting(false); // Do this when you have loaded all component logic


      }else{
        // show Select Studies menu incase no 
        setModalVisible(true);
      }



    }, [])

    let storeStudyMap = useSelector((state: RootState) => state.studyMapping);

    useEffect(() => {

        // Case 1. First Decrypted Value is loaded -> Studies is loaded
        // Case 2. Studies is Loaded -> Next Decrypted Value is Loaded

        // Check both conditions and then set study and organization and also urlBasedRouting is true and then deactivate urlBasedRouting 

        if(Object.keys(storeStudyMap.studyMapping).length !== 0 && selectedStudyIdFromDynamicURL && participantDetailURLRedirect){

          // Now write the logic here to manipulate the study in the global state

          let newStudy : StudyInfo = {
            StudyOrg: "",
            StudyName: ""
          };

          const checkStudyIDinStudyMap = () => {

            let checkResult = false;

            Object.entries(storeStudyMap.studyMapping).forEach(([studyName, details]) => {
              // const { organization_name, study_id } = details;
              // console.log(studyName)
              if(studyName == selectedStudyIdFromDynamicURL){
                checkResult = true;
              }

            });

            return checkResult;
          }

          if(checkStudyIDinStudyMap()){

            newStudy = {
              StudyOrg: storeStudyMap.studyMapping[selectedStudyIdFromDynamicURL]?.organization_name,
              StudyName: selectedStudyIdFromDynamicURL
            }
          
            dispatch(updateStudyInfo(newStudy));

            // !!!!!!!! Here only you will call the participantDetailModal and initialize the data for it

            
            setCurrentParticipantInFocus({'participant_name': requestedParticipantFromDynamicURL?.participant_name, 'participant_euid' : requestedParticipantFromDynamicURL?.participant_euid})



            setIsParticipantDetailModalVisible(true);



            // TODO: 
            // 1. [Done] Call ParticipantDetailModal from here using a intermediate statevariable (basic functionality) (Intermediate State since we dont buggy code to store)
            // 2. Add CustomTime Range support in ParticipantDetailsModal
            // 3. Do a ton of testing
            // 4. Implement this for dashboardmobile
            // 5. Also need to disable selectstudies dropdown when its loading
            // 6. Push all changes to the cloud (Backend and Frontend)
            // 7. Also verify whether all URL's are redirected to SPA
            // 8. Make the cloud part a module

            




          }else{

            // This runs when buggy code is received - ask dashboard user to select a study
            // Make Modal Visible
            setModalVisible(true);


          }
          
          // In both case set participantDetailURLRedirect to false
          // And then clear the query string parameters
          setparticipantDetailURLRedirect(false);

          // Remove query parameters from the URL (So that when the dashboard is switched back it doesnot load the same participant)
          // The below happens without refreshing the page 
          navigate(location.pathname, { replace: true });

        }


    }, [storeStudyMap, selectedStudyIdFromDynamicURL])









    useEffect(() => {
    
        if(Object.keys(storeStudyMap.studyMapping).length !== 0 && storeStudy.study.StudyName && selectedDateRange?.from != undefined && selectedDateRange?.to != undefined){
    
          // const timerangeFrom = Math.floor(selectedDateRange?.from.getTime() / 1000);
          // const timerangeTo = Math.floor(selectedDateRange?.to.getTime() / 1000);
    
          console.log("Fetching data w.r.to custom study and timerange", storeStudy.study.StudyName, "- From:" , selectedDateRange?.from.toISOString(), " To:", selectedDateRange?.to.toISOString())
          
          // console.log("Store Study ID: ", storeStudyID.studyMapping[storeStudy.study.StudyName].study_id)
    
          setLoading(true);
    
          const fetchData = async () => {
            setLoading(true);
            setNoData(false);
            setSharedState(true)
            setRefereshing(true);
    
            console.log('Study Name Sent:', storeStudy.study.StudyName, "-");
    
            try {
              const response = await axios.get(
                `${BASE_URL}/getAnomalyCountData/?study_name=${storeStudy.study.StudyName}&timezone_string=${selectedTimezoneString}&days=${timelineDays}&timerange_from=${selectedDateRange?.from?.toISOString()}&timerange_to=${selectedDateRange?.to?.toISOString()}&study_id=${storeStudyID.studyMapping[storeStudy.study.StudyName].study_id}`,
              );
          
              if (response.data['statusCode'] === 200) {  
                console.log("UNTOUCHED DATA", response.data);
                console.log("THE DATA IS HERE", JSON.parse(response.data['body'])['participant_data']);
                setPlotData(JSON.parse(response.data['body'])['daily_data']);
                setStudyName(JSON.parse(response.data['body'])['study_name']);
                setNoDataParticipants(JSON.parse(response.data['body'])['participant_euid_pairs_with_no_data'])
                console.log("THE PLOT DATA IS HERE");
                console.log(JSON.parse(response.data['body']));
              } else if(response.data['statusCode'] === 204){
                setStudyName(storeStudy.study.StudyName);
                setNoData(true);
              } else {
                console.log("UNTOUCHED ERROR", response);
                throw new Error('Failed to fetch data');
              }
            } catch (err: unknown) {
              if (axios.isAxiosError(err)) {
                // The error is an Axios error
                if (err.response) {
                  // Server responded with a status other than 2xx
                  console.error('Error response:', err.response);
                  console.error('Status code:', err.response.status);
                  console.error('Error data:', err.response.data);
                } else if (err.request) {
                  // Request was made but no response was received
                  console.error('No response received:', err.request);
                } else {
                  // Something else happened during setup
                  console.error('Error', err.message);
                }
              } else {
                // The error is not an Axios error
                console.error('Unknown error:', err);
              }
            } finally {
              setLoading(false);
              setSharedState(false);
            //   setRefreshDate(getCurrentDate());
              setRefereshing(false);
            }
          };
          
          fetchData();
        }
    
      }, [selectedDateRange, storeStudy]);
    

    const showParticipantDetailsModal = ({ participant_name, participant_euid }: ParticipantModalDetails) => {
      setCurrentParticipantInFocus({ participant_name, participant_euid });
      setIsParticipantDetailModalVisible(true);
    };

    return (

        <>
            <div className="dashboard-mobile-page">
                <div className="content">

                    <div className="tab-header">

                        <div className="table-info-section">

                            <div className="info-section-container">
                                {isLoading ? (
                                    <Skeleton></Skeleton>
                                    ) : (
                                    <>
                                    <div className="study-name">
                                        <span className="title title-medium">Study</span> 
                                        <span>&nbsp;</span>
                                        <span className="title title-medium">{studyName}</span>
                                        {/* <span className="title title-large">A2</span> */}
                                    </div>
                                    <div className="participant-count">
                                        <span className="label label-medium">{noData ? 0 : plotData.length + noDataParticipants.length}</span>
                                        {/* <span className="label label-medium">92</span> */}
                                        <span>&nbsp;</span>
                                        <span className="label label-medium">Participants</span>
                                    </div>
                                    </>
                                )}
                            </div>

                            <div className="quick-actions">
                                <div className="quick-actions-buttons">
                                    {/* <InputfieldWithPlaceholder
                                        collapsable={true}
                                        leftIcon={<SearchIcon fill={getComputedStyle(document.documentElement).getPropertyValue("--on-surface-variant")}></SearchIcon>}
                                        rightActionIcon={<ClearIcon fill={getComputedStyle(document.documentElement).getPropertyValue("--on-surface-variant")} />}
                                        onRightActionClicked={() => {
                                            setSearchQuery("");
                                            search("");
                                            setSearchActive(false);
                                        }}
                                        value={searchQuery}
                                        onValueChanged={(value) => {
                                        if (value !== "") {
                                            setSearchActive(true);
                                        } else {
                                            setSearchActive(false);
                                        }
                                        setSearchQuery(value);
                                        search(value);
                                        }}
                                        type={searchActive && items.length === 0 ? InputfieldType.Error : InputfieldType.Normal}
                                        placeholderValue={placeholderValue}
                                    ></InputfieldWithPlaceholder>

                                    <MasterButton
                                        options={{
                                        layoutType: ButtonLayoutType.Icon,
                                        label: "Filter & Sorting",
                                        variation: ButtonVariation.Outlined,
                                        icon: filterIcon,
                                        size: ButtonSize.Medium,
                                        }}
                                        onClick={() => {
                                        console.log("Filter & Sorting button refresh");
                                        // loadData(selectedStudy); // !!!!!!!!!!!!! Need to use the studyInfo state here to get the relevant study and load the data through the API
                                        }}
                                        disabled={isLoading}
                                    ></MasterButton>   */}
                                </div>
                            </div>
                            
                        </div>

                    </div>

                    <CustomTimeSelectionButtonBar onSelect={handleTimeRangeSelection} modalSize={{ height: `calc(100vh - 250px)` }} parentID="dashboard-time-selector-button-bar" showCustom={false} isMobile={true} defaultTime="1 Week" />

                    <div className="separator"></div>

                    <div className="chart-cards-scroll-menu">

                        {isLoading ? (
                            <div className="loading-center-content">
                              {participantDetailURLRedirect ? (
                                    <span className="title title-small">
                                        Loading Participant Detail for the requested Participant ...
                                    </span>
                                ) : (
                                    <span className="title title-small">
                                        Loading participant data for the {storeStudy.study.StudyName} study ...
                                    </span>
                              )}
                            </div>
                            ) : noData ? (

                            <div className="loading-center-content">
                                <span className="title title-small">There is no available data for the {storeStudy.study.StudyName} study in the selected time range.</span>
                            </div>

                            ) : (

                            <>

                                {/* <div style={{ height: '20px', width: '100%'}}></div> */}

                                {plotData && plotData.map((x: any, i: number) => (

                                  <DashboardMobileParticipantInnerDetail
                                    key={i}
                                    participant_name={x.participant_name}
                                    cnt_indeterminate={ x.cnt_indeterminate }
                                    cnt_pos={ x.cnt_pos  }
                                    timeline={timelineDays}
                                    interval_counts={x.interval_counts}
                                    onClick={() => showParticipantDetailsModal({'participant_name' : x.participant_name, 'participant_euid': x.euid})}
                                  />

                                ))

                                }

                                



                                {/* {plotData && plotData.map((x: PlotData, i: number) => (
                                
                                <div className="participant-chart-data" key={i}>

                                    <div className="participant-detail" onClick={() => showParticipantDetailsModal({'participant_name' : x.participant_name, 'participant_euid': x.euid})}>
                                      <div className="inner-participant-detail">
                                          <span className="title title-small">{x.participant_name}</span>
                                          <DashboardParticipantInnerDetail
                                            participant_name={x.participant_name}
                                            cnt_indeterminate={x.cnt_indeterminate}
                                            cnt_pos={x.cnt_pos}
                                            last_updated_date={x.last_updated_date}
                                            timeline={currentTimeline}
                                          />
                                      </div>
                                    </div>
                                    <div className="participant-chart" id={`plot-id-${i}`}>
                                      <Plot
                                          data={JSON.parse(x.chart_data).data}
                                          layout={{...JSON.parse(x.chart_data).layout,
                                          width: plotWidth,         // Modify the width of the plot
                                          height: 100, 
                                          showlegend: false, 
                                          xaxis: {
                                              ...JSON.parse(x.chart_data).layout.xaxis,
                                              showticklabels: false,  // Show the tick labels for the common X-axis
                                          },
                                          dragmode: false, // 'none' will enable the drag mode - this is what we want to use inside the participant detail page
                                          
                                          }}
                                          key={i} // Always include a key when rendering lists in React
                                          config={{
                                          displayModeBar: false, // Disable the mode bar completely
                                          doubleClick: false,
                                          }}
                                          
                                          className="no-cursor custom-border-allsides"
                                      />
                                    </div>
                                </div>
                                ))}

                                {noDataParticipants && noDataParticipants.map((x: string[], i: number) => (
                                <div className="participant-chart-data" key={plotData.length+i}>
                                    <div className="participant-detail" onClick={() => showParticipantDetailsModal({'participant_name' : x[0], 'participant_euid': x[1]})}>
                                    <div className="inner-participant-detail">
                                        <span className="title title-small">{x[0]}</span>
                                    </div>
                                    </div>
                                    <div className="participant-chart" id={`plot-id-${plotData.length+i}`}>
                                    <div className="participant-chart-no-data" style={{ width: plotWidth + 'px', height: 100 + 'px' }}>
                                        <span className="label label-medium">Participant has not synced in the selected time range.</span>
                                    </div>
                                    </div>
                                </div>
                                ))} */}

                                {noDataParticipants && noDataParticipants.map((x: string[], i: number) => (
                                  // <div className="participant-chart-data" key={plotData.length+i}>
                                  //     <div className="participant-detail" onClick={() => showParticipantDetailsModal({'participant_name' : x[0], 'participant_euid': x[1]})}>
                                  //     <div className="inner-participant-detail">
                                  //         <span className="title title-small">{x[0]}</span>
                                  //     </div>
                                  //     </div>
                                  //     <div className="participant-chart" id={`plot-id-${plotData.length+i}`}>
                                  //     <div className="participant-chart-no-data" style={{ width: plotWidth + 'px', height: 100 + 'px' }}>
                                  //         <span className="label label-medium">Participant has not synced in the selected time range.</span>
                                  //     </div>
                                  //     </div>
                                  // </div>

                                  <div className="no-data-participants-mobile" key={plotData.length+i} onClick={() => showParticipantDetailsModal({'participant_name' : x[0], 'participant_euid': x[1]})}>
                                    <div>
                                      <span className="title title-medium">{x[0]}</span>
                                    </div>
                                    <div>
                                      <span className="label label-medium">Participant has not synced in the selected time range.</span>
                                    </div>
                                  </div>



                                ))}

                                <div style={{ height: '200px', width: '100%'}}></div>

                            </>
                            )}


                    </div>


                </div>

                {isParticipantDetailModalVisible && (
                  <ModalOverlay
                    closeModal={() => {
                      setIsParticipantDetailModalVisible(false);
                    }}
                    className="dashboard-participant-details-modal"
                  >
                    <DashboardParticipantDetailsModal
                      onCloseClicked={() => {
                        setIsParticipantDetailModalVisible(false);
                      }}
                      participantName={currentParticipantInFocus?.participant_name}
                      participantEUID={currentParticipantInFocus?.participant_euid}
                      organizationName={storeStudy.study.StudyOrg}
                      studyName={storeStudy.study.StudyName}>
                    </DashboardParticipantDetailsModal>
                  </ModalOverlay>
                )}

                {isModalVisible && (
                    <ModalOverlay
                        closeModal={() => {
                        // setModalVisible(false);
                        }}
                        className="dashboard-studies-selection-modal-mods"
                    >
                        <DashboardSelectStudiesModal
                        onCloseClicked={() => {
                            setModalVisible(false);
                        }}
                        onSendData={handleTimelineFromModal}
                        ></DashboardSelectStudiesModal>
                    </ModalOverlay>
                )}



            </div>

        
        </>

    )
};

export default DashboardMobile;